import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '@components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../material.module';
import { CUSTOM_BREAKPOINTS } from './breakpoint/custom-breakpoints';
import { CustomFlexDirective } from './breakpoint/custom-flex.directive';
import { TemplateAllInLargeComponent } from './template-all-in-large/template-all-in-large.component';
import { TemplateAllInRouterComponent } from './template-all-in-router/template-all-in-router.component';
import { TemplateAllInSmallComponent } from './template-all-in-small/template-all-in-small.component';
import { TemplateFullAnchorComponent } from './template-full-anchor/template-full-anchor.component';
import { TemplateFullComponent } from './template-full/template-full.component';
import { TemplateHalvesComponent } from './template-halves/template-halves.component';
import { TemplateSecondaryLargeComponent } from './template-secondary-large/template-secondary-large.component';
import { TemplateSecondarySmallComponent } from './template-secondary-small/template-secondary-small.component';
import { TemplateThirdsComponent } from './template-thirds/template-thirds.component';

@NgModule({
  declarations: [
    CustomFlexDirective,
    TemplateFullComponent,
    TemplateSecondaryLargeComponent,
    TemplateFullAnchorComponent,
    TemplateThirdsComponent,
    TemplateAllInLargeComponent,
    TemplateAllInSmallComponent,
    TemplateSecondarySmallComponent,
    TemplateHalvesComponent,
    TemplateAllInRouterComponent
  ],
  imports: [
    FlexLayoutModule.withConfig({ disableDefaultBps: true }, CUSTOM_BREAKPOINTS),
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    ComponentsModule
  ],
  exports: [
    CustomFlexDirective,
    TemplateFullComponent,
    TemplateSecondaryLargeComponent,
    TemplateFullAnchorComponent,
    TemplateThirdsComponent,
    TemplateAllInLargeComponent,
    TemplateAllInSmallComponent,
    TemplateSecondarySmallComponent,
    TemplateHalvesComponent,
    TemplateAllInRouterComponent
  ]
})
export class LayoutModule {}
